exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_2FIU1 {\n    padding: 0 80px;\n}\n\n.divition_NECvv {\n    margin: 10px 0;\n    border-top: 5px solid #040404;\n}\n\n.infoContainer_2FIU1 > p {\n    padding: 15px 0;\n    font-weight: 800;\n    font-style: italic;\n    letter-spacing: 1px;\n    line-height: 25px;\n}\n\n.infoContainer_2FIU1 > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.gapSection3_2G1JT {\n    height: 240px;\n}\n\n.signatureSize_8CP3F img {\n    max-width: 200px;\n    max-height: 80px;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_2FIU1",
	"divition": "divition_NECvv",
	"gapSection3": "gapSection3_2G1JT",
	"signatureSize": "signatureSize_8CP3F"
};